import React from "react";
import { Alert, Button, Flex, Typography } from "antd";
import { WifiOutlined } from "@ant-design/icons";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";

const AiAssessmentOfflineMessage: React.FC = () => {
  const { isOffline, setIsOffline } = useAIAssessmentContext();
  
  if (!isOffline) return null;

  const handleOfflineRetry = async () => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 4000);

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/ping`,
        {
          method: "GET",
          signal: controller.signal,
          cache: "no-store",
        }
      );

      clearTimeout(timeoutId);

      if (response.ok || response.status === 401) {
        // Server reachable (even if unauthorized)
        setIsOffline(false);
      } else {
        setIsOffline(true);
      }
    } catch {
      setIsOffline(true);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(2px)",
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
      }}
    >
      <Alert
        message={
          <Flex align="center" gap={12}>
            <WifiOutlined style={{ fontSize: "28px" }} />
            <Typography.Title level={3} style={{ color: "#1f1f1f", margin: 0 }}>
              No Internet Connection
            </Typography.Title>
          </Flex>
        }
        description={
          <Flex vertical gap={20} style={{ marginTop: "16px" }}>
            <Typography.Text
              style={{
                color: "#333",
                opacity: 0.8,
                fontSize: "16px",
                textAlign: "center",
                lineHeight: "1.6",
                wordBreak: "break-word",
              }}
            >
              Your internet connection has been lost during the interview. Your
              progress is automatically saved. Please check your connection and
              try to reconnect.
            </Typography.Text>
            <Flex vertical gap={12} align="center">
              <Button
                type="primary"
                icon={<WifiOutlined />}
                onClick={handleOfflineRetry}
                size="large"
              >
                Check Connection
              </Button>
              <Typography.Text
                style={{
                  color: "#666",
                  opacity: 0.8,
                  fontSize: "14px",
                  textAlign: "center",
                }}
              >
                ⚠️ Do not close this tab - your interview will resume when
                connection is restored
              </Typography.Text>
            </Flex>
          </Flex>
        }
        type="error"
        showIcon={false}
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          border: "none",
          borderRadius: "12px",
          maxWidth: "600px",
          width: "100%",
        }}
      />
    </div>
  );
};

export default AiAssessmentOfflineMessage;
